//src-mobile/App.tsx

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { RequireAuth } from "../shared/RequireAuth";
import { useAuth } from '../shared/contexts/AuthContext';
import { ChatProvider } from '../shared/contexts/ChatContext';

import { useParams } from "react-router-dom";

// -----------------------------------------------
// Legal
// -----------------------------------------------
import TermsOfUse from '../shared/legal/TermsOfUse'; 
import PrivacyPolicy from '../shared/legal/PrivacyPolicy';


// -----------------------------------------------
// Homepage
// -----------------------------------------------
import Home from './pages/Administration/Home';
import StartPage from './pages/Administration/StartPage';
import LanguageSelectorMobile from './components/LanguageSelectorMobile';
import ProfileSetup from './pages/Administration/ProfileSetup';
import ForgotPassword from './pages/Administration/ForgotPassword';
import ResetPassword from './pages/Administration/ResetPassword';
import GalleryMobile from './pages/Gallery/GalleryMobile';
import FollowingMobile from './pages/Gallery/FollowingMobile';
import VisitorPostingsMobile from './pages/Gallery/VisitorPostingsMobile';
import MyLikes from './pages/Gallery/MyLikes';
import GalleryEditPosting from './pages/Gallery/GalleryEditPosting';
import GalleryPostEditing from './pages/MyProfile/GalleryPostEditing'; 
import OpenViewer from './pages/Gallery/OpenViewer';
import OpenViewerMD from './pages/Gallery/OpenViewerMusicdetail';

//-------------------------------------------------------
//Administration
//-------------------------------------------------------

import ConfirmEmail from '../shared/Administration/ConfirmEmail';


//-------------------------------------------------------------------

import FollowersListMobile from './pages/MyProfile/FollowersListMobile';
import FollowingListMobile from './pages/MyProfile/FollowingListMobile';
import NotificationsMobile from './pages/MyProfile/NotificationsMobile';   

import MenuMobile from './components/MenuMobile';
import SettingsStartMobile from './pages/Settings/SettingsStartMobile';
import AccountSettingsMobile from './pages/Settings/AccountSettingsMobile';
import DataPrivacyMobile from './pages/Settings/DataPrivacyMobile';
import SecuritySettingsMobile from './pages/Settings/SecuritySettingsMobile';
import ProfileManagementMobile from './pages/Settings/ProfileManagementMobile';
import HelpSupportStart from "./pages/HelpSupport/HelpSupportStart";
import AccountAdministration from "./pages/HelpSupport/AccountAdministration";
import PlatformGuide from "./pages/HelpSupport/PlatformGuide";
import AdvertisementGuide from "./pages/HelpSupport/AdvertisementGuide";
import Faq from "./pages/HelpSupport/Faq";
import ContactSupport from "./pages/HelpSupport/ContactSupport";


import ProfileMobile from './pages/MyProfile/ProfileMobile';
import MyPostingsMobile from './pages/MyProfile/MyPostingsMobile';
import MusicDetailPage from './pages/Collections/MusicDetailPage';
import MusicDetailPosts from './pages/Gallery/MusicDetailPosts';
import LocationCollectionMobile from './pages/Collections/LocationCollectionMobile';
import LocationPostMobile from './pages/Gallery/LocationPostMobile';

import BlockedList from "./pages/MyProfile/BlockedList";
import ImageFilter from './pages/Gallery/ImageFilter';
import VideoFilter from './pages/Gallery/VideoFilter';
import AddMusic from './pages/Gallery/AddMusic';
import ChooseTrack from './pages/Gallery/ChooseTrack';
import EditMedia from './components/EditMedia';
  
import Chat from './pages/Chat/Chat';
import ActiveChatMobile from './pages/Chat/ActiveChatMobile';

//Location
import ChangeLocationGeo from './pages/Location/ChangeLocationGeo';
import ChangeLocationNogeo from './pages/Location/ChangeLocationNogeo';
import ConfirmLocation from './pages/Location/confirm-location';
import { useLocationHandling } from './pages/Location/useLocationHandling';

// Privacy Changes
import FirstRunPrivacy from './pages/Administration/FirstRunPrivacy';
import RequirePrivacyChange from './pages/Administration/RequirePrivacyChange';
import RequirePrivacyChangeCL from './pages/Administration/RequirePrivacyChangeCL';
import RequirePrivacyChangeMap from './pages/Administration/RequirePrivacyChangeMap';

import GalleryPosting from './pages/Gallery/GalleryPosting';

// -----------------------------------------------
// Administration
// -----------------------------------------------
/*
import ConfirmEmail from './pages/Administration/ConfirmEmail';
import EmailSent from './pages/Administration/EmailSent';
import CheckEmail from './pages/Administration/CheckEmail';


// -----------------------------------------------
//Help & Support
// -----------------------------------------------
import PlatformGuide from "./pages/HelpSupport/PlatformGuide";
import AccountAdministration from "./pages/HelpSupport/AccountAdministration";
import Faq from "./pages/HelpSupport/Faq";
import AdvertisementGuide from "./pages/HelpSupport/AdvertisementGuide";
import ContactSupport from "./pages/HelpSupport/ContactSupport";


// -----------------------------------------------
// Settings
// -----------------------------------------------


// -----------------------------------------------
// Pages/Menu
// -----------------------------------------------
//Media Feeds

//Profile

//Location

//Notifications


// -----------------------------------------------
//Gallery posting pages
// -----------------------------------------------


//Components

// -----------------------------------------------
// Chat
// -----------------------------------------------

// -----------------------------------------------
//Advertisement
// -----------------------------------------------
import AdvertisementStart from "./pages/Advertisement/AdvertisementStart";
import AdUpload from "./pages/Advertisement/AdUpload";
import AdOverview from "./pages/Advertisement/AdOverview";
import ViewAdDetail from "./pages/Advertisement/ViewAdDetail";
import ManageBillings from "./pages/Advertisement/ManageBillings";
import ChangePayment from "./pages/Advertisement/ChangePayment";
//Ad Media
import AdImageFilter from "./pages/Advertisement/MediaEdit/AdImageFilter";
import AdVideoFilter from "./pages/Advertisement/MediaEdit/AdVideoFilter";
import AdAddMusic from "./pages/Advertisement/MediaEdit/AdAddMusic";
import AdChooseTrack from "./pages/Advertisement/MediaEdit/AdChooseTrack";
*/


function RoutesWithRemount() {
  const location = useLocation();
  const { userId } = useParams(); // This will give you the `userId` from the route
 
  return (
    <Routes location={location} key={location.key}>
      <Route path="/" element={<StartPage />} />
      <Route path="/start" element={<Navigate to="/" replace />} />
      <Route path="/language" element={<LanguageSelectorMobile />} />
      <Route path="/profile-setup" element={<ProfileSetup />} /> 
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/helpsupportstart" element={<HelpSupportStart />} />
      <Route path="/help/account" element={<AccountAdministration />} />
      <Route path="/help/platform" element={<PlatformGuide />} />
      <Route path="/help/faq" element={<Faq />} />
      <Route path="/help/advertisement" element={<AdvertisementGuide />} />
      <Route path="/help/contact" element={<ContactSupport />} />      

      <Route path="/confirm-email" element={<ConfirmEmail />} />
      
{/* Legal */}
  <Route path="/legal/termsofuse" element={<TermsOfUse />} />
  <Route path="/legal/privacypolicy" element={<PrivacyPolicy />} />

      <Route element={<RequireAuth />}>
        <Route path="/menu" element={<MenuMobile />} />
        <Route path="/gallery" element={<GalleryMobile />} />
        <Route path="/following" element={<FollowingMobile />} />
        <Route path="/visitor-profile/:userId" element={<VisitorPostingsMobile />} />
        <Route path="/mylikes" element={<MyLikes />} />
        <Route path="/musicdetails/:id" element={<MusicDetailPage />} />
        <Route path="/musicdetails/:trackId/post/:postId" element={<MusicDetailPosts />} />
        <Route path="/location-collection" element={<LocationCollectionMobile />} />
        <Route path="/location-post-detail/:postId" element={<LocationPostMobile />} />
      
        <Route path="/profile" element={<ProfileMobile />} />
        <Route path="/followers-list" element={<FollowersListMobile />} />
        <Route path="/following-list" element={<FollowingListMobile />} />

        <Route path="/notifications" element={<NotificationsMobile />} />
        <Route path="/my-posts" element={<MyPostingsMobile />} />
        <Route path="/openviewer" element={<OpenViewer />} />
        <Route path="/openviewermd" element={<OpenViewerMD />} />

        <Route path="/editor/image/:id" element={<ImageFilter />} />
        <Route path="/editor/video/:id" element={<VideoFilter />} />
        <Route path="/add-music" element={<AddMusic />} />
        <Route path="/choose-track" element={<ChooseTrack />} />

        <Route path="/gallery-posting" element={<GalleryPosting />} />
        <Route path="/posting/edit/:postId" element={<GalleryEditPosting />} />
        <Route path="/edit/gallery/:id" element={<GalleryPostEditing />} />
        <Route path="/edit-media" element={<EditMedia />} />

        <Route path="/blocked" element={<BlockedList />} />

        {/* Location */}
        <Route path="/change-location-geo" element={<ChangeLocationGeo />} />
        <Route path="/change-location-nogeo" element={<ChangeLocationNogeo />} />
        <Route path="/confirm-location" element={<ConfirmLocation />} />

        <Route path="/firstRun" element={<FirstRunPrivacy />} />
        <Route path="/require-privacy-change" element={<RequirePrivacyChange />} />
        <Route path="/require-privacy-changeCL" element={<RequirePrivacyChangeCL />} />
        <Route path="/require-privacy-changeMap" element={<RequirePrivacyChangeMap />} />

        <Route path="/chat" element={<Chat />} />
        <Route path="/chat/:userId" element={<Chat />} />

        <Route
          path="/activechat"
          element={
            <ActiveChatMobile
              search=""
              onSearchChange={() => {}}
              suggestions={[]}
              onSelectSuggestion={() => {}}
              activeChats={[]}
              onSelectChat={() => {}}
              onDeleteChat={() => {}}
              selectedUserId={userId}
            />
          }
        />

        <Route
          path="/activechat/:userId"
          element={
            <ActiveChatMobile
              search=""
              onSearchChange={() => {}}
              suggestions={[]}
              onSelectSuggestion={() => {}}
              activeChats={[]}
              onSelectChat={() => {}}
              onDeleteChat={() => {}}
              selectedUserId={userId}
            />
          }
        />

        <Route path="/settings/overview" element={<SettingsStartMobile />} />
        <Route path="/settings/account" element={<AccountSettingsMobile />} />
        <Route path="/settings/privacy" element={<DataPrivacyMobile />} />
        <Route path="/settings/security" element={<SecuritySettingsMobile />} />
        <Route path="/settings/profile-management" element={<ProfileManagementMobile />} />
      </Route>
    </Routes>
  );
}

// -----------------------------------------------
// Routes Wrapper
// -----------------------------------------------
function AppWrapper() {
  const { isAuthenticated, user, token, isBootstrapping } = useAuth();
  const { initializeLocation } = useLocationHandling();

  
  React.useEffect(() => {
    if (isAuthenticated && user && token) {
      initializeLocation();
    }
  }, [isAuthenticated, user, token]);


  React.useEffect(() => {
  const fixMobileSafariTaps = () => {
    // Restore pointer/touch behavior
    document.body.style.pointerEvents = "auto";
    document.body.style.touchAction = "manipulation";
    document.body.style.overflow = "auto";

    // Safari tap recovery (TypeScript-safe)
    (document.body.style as any).webkitUserSelect = "auto";
    (document.body.style as any).webkitTouchCallout = "default";

    // Force repaint to rebind events
    document.body.style.transform = "translateZ(0)";
    requestAnimationFrame(() => {
      document.body.style.transform = "";
    });
  };

  fixMobileSafariTaps();

  // Run after navigation changes
  window.addEventListener("popstate", fixMobileSafariTaps);
  window.addEventListener("hashchange", fixMobileSafariTaps);

  return () => {
    window.removeEventListener("popstate", fixMobileSafariTaps);
    window.removeEventListener("hashchange", fixMobileSafariTaps);
  };
}, []);



  if (isBootstrapping) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        Loading...
      </div>
    );
  }

  return (
<div
  style={{
    backgroundColor: 'var(--bg)',
    color: 'var(--text)',
    minHeight: '100vh',
    width: '100%',
    overflowX: 'hidden',
    pointerEvents: 'auto',
    touchAction: 'manipulation'
  }}
>
      <RoutesWithRemount />
    </div>
  );
}


// -----------------------------------------------
// Mobile App Shell
// -----------------------------------------------
export default function App() {
  return (
    <Router>
      <ChatProvider>
      <AppWrapper />
      </ChatProvider>
    </Router>
  );
}
